// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3625bbf1","865":"d43f6931"}[chunkId] + ".chunk.js";
};